module.exports = __webpack_public_path__ + "img/1513090341.3a78eefc.jpg";